import { PortfolioSummaryConfigurationState } from 'widgets/portfolioSummary/store/instances/configuration/PortfolioSummaryConfigurationState';
import { WidgetType } from 'widgets/WidgetType';
import {
    WidgetSetConfigAction,
    buildUpdateWidgetConfigurationActionCreator,
    createLoadWidgetConfigurationAction,
    WidgetLoadConfigAction,
} from 'widgets/store/configuration/actions';
import { SetGridColumnWidthAction } from 'widgets/store/grid/columnWidth/actions';
import { PortfolioSummaryColumn } from 'widgets/portfolioSummary/grid/portfolioSummaryGridColumns';

export type PortfolioSummaryConfigAction =
    | SetGridColumnWidthAction<PortfolioSummaryColumn>
    | WidgetSetConfigAction<PortfolioSummaryConfigurationState>
    | WidgetLoadConfigAction<PortfolioSummaryConfigurationState>;

export const updatePortfolioSummaryConfiguration =
    buildUpdateWidgetConfigurationActionCreator<PortfolioSummaryConfigurationState>(
        WidgetType.PORTFOLIO_SUMMARY
    );

export const createLoadPortfolioSummaryConfigurationAction =
    createLoadWidgetConfigurationAction<PortfolioSummaryConfigurationState>(
        WidgetType.PORTFOLIO_SUMMARY
    );
